import { render, staticRenderFns } from "./line-item.vue?vue&type=template&id=db1a696a&scoped=true&"
import script from "./line-item.vue?vue&type=script&lang=js&"
export * from "./line-item.vue?vue&type=script&lang=js&"
import style0 from "./line-item.vue?vue&type=style&index=0&id=db1a696a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1a696a",
  null
  
)

export default component.exports